(() => {
  const enhanceWhatnotMenu = () => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    document.querySelectorAll('.hos-whatnot-nav').forEach((menuItem) => {
      const details = menuItem.querySelector('details');
      const summary = details?.querySelector('summary');
      if (!details || !summary || details.dataset.hoverReady === 'true') return;

      details.dataset.hoverReady = 'true';
      let closeTimer;

      const openMenu = () => {
        window.clearTimeout(closeTimer);
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        closeTimer = window.setTimeout(() => {
          if (!menuItem.matches(':hover') && !details.contains(document.activeElement)) {
            details.open = false;
            summary.setAttribute('aria-expanded', 'false');
          }
        }, 120);
      };

      menuItem.addEventListener('mouseenter', openMenu);
      menuItem.addEventListener('mouseleave', closeMenu);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceWhatnotMenu, { once: true });
  } else {
    enhanceWhatnotMenu();
  }
})();
